import { isAllowedToPlay } from '@svenskaspelab/nova-account-sport/isAllowedToPlay';
import type { DialogConfig } from '@svenskaspelab/nova-foundation/nextjs/dialog';
import { MiddlewarePaymentError, type PreMiddlewareFn } from '@svenskaspelab/nova-payment-sport';
import type { Wager } from '@svenskaspelab/nova-payment-sport/wager';

/**
 * Middleware to check if the player has an active exclusion (spelpaus) before allowing payment.
 *
 * @param showDialog The function to show a dialog.
 * @param vertical The vertical to check exclusion for.
 * @returns Pre-middleware function that checks player exclusion and throws if the player is excluded.
 */
export function isAllowedToPlayMw(
  showDialog: (props: DialogConfig, meta?: string[]) => Promise<void>,
  vertical: string
): PreMiddlewareFn<Wager> {
  return ({ payment }) =>
    async (next) => {
      try {
        const hasRegularWager = payment.getPayableItems().some((item) => !item.getIsMarketplaceWager());
        // Only check for exclusion for normal customer wager. Not for Spela tillsammans games.
        if (hasRegularWager) {
          const canPlay = await isAllowedToPlay(showDialog, vertical);
          if (!canPlay) {
            next(new MiddlewarePaymentError({ clientCode: 'USER_HAS_EXCLUSION' }));
            return;
          }
        }
        next();
      } catch {
        const mwError = new MiddlewarePaymentError({ clientCode: 'USER_HAS_EXCLUSION' });
        next(mwError);
      }
    };
}
